import React, { useState, useEffect } from 'react';
import { TextField as MUITextField } from '@mui/material';
import { useSelector } from 'react-redux';
import TEXT from './text';

const EmailComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const language = useSelector(state => state.App_Settings.language);
    const { options = {}, constrains = {} } = properties;

    const [error, setError] = useState(false);
    const [inputValue, setInputValue] = useState(value !== undefined ? value : (options.defaultValue || options.value || ''));

    // Sync with parent value changes
    useEffect(() => {
        if (value !== undefined && value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const defaultEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const validateEmail = (value) => {
        const pattern = options.useCustomEmailRegex
            ? new RegExp(constrains.pattern)
            : defaultEmailRegex
            ;
        console.log('Using email validation pattern:', pattern);
        const isValid = pattern ? pattern.test(value) : true;
        console.log(`Validating email: ${value}, isValid: ${isValid}`);
        return isValid;
    };

    const handleChange = (event) => {
        const newValue = event.target.value;
        console.log(`Input value changed: ${newValue}`);
        setInputValue(newValue);

        let isValid = true;
        if (newValue.trim() === '') {
            console.log('Input is empty, clearing error.');
            setError(false);
            isValid = options.required ? false : true;
        } else if (!validateEmail(newValue)) {
            console.log('Input is invalid, setting error.');
            setError(true);
            isValid = false;
        } else {
            console.log('Input is valid, clearing error.');
            setError(false);
            isValid = true;
        }

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(newValue);
        }

        // Update validity
        if (validityUpdaterCallback) {
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            console.log('Calling onChange callback with value:', newValue);
            options.onChange(newValue);
        }
    };

    console.log(`Rendering EmailComponent with value: ${inputValue}, error: ${error}`);

    return (
        <MUITextField
            label={options.label || TEXT.Email[language]}
            type="email"
            variant={options.variant || 'outlined'}
            value={inputValue}
            onChange={handleChange}
            placeholder={options.placeholder || ''}
            fullWidth={options.fullWidth !== false}
            required={options.required || false}
            error={error}
            helperText={error ? (TEXT.InvalidEmail[language] || "Please enter a valid email address.") : ''}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

export default EmailComponent;
